import React from 'react';
import TrustedSlider from '../Slider/TrustedSlider';
function DeployedSection() {
  return (
    <>
      <p className="text-16 md:text-18 font-medium text-center my-3 md:my-5">
        Deployed for 300,000+ salespeople in 65+ world leading enterprises
      </p>

      <div>
        <TrustedSlider />
      </div>
    </>
  );
}

export default DeployedSection;
